import { render } from "./RecordingIndicator.vue?vue&type=template&id=c7f25234"
const script = {}
script.render = render

export default script